// extracted by mini-css-extract-plugin
module.exports = {"AdminAuthForm":"AdminAuthForm_AdminAuthForm__-sGEs","Switch":"AdminAuthForm_Switch__2UJZy","ButtonContainer":"AdminAuthForm_ButtonContainer__2_hYO"};